import {createElement, PropTypes, cloneElement} from 'rlink-react';
import {NavLink} from 'rlink-router/component';
import {mergeStaticOptions} from 'rlink-utils/object';

import TextContentInput from './TextContentInput';

export default class ContentRefInput extends TextContentInput {
  get inputType () {
    return 'url';
  }

  componentWillMount () {
    this.props.repoStore.registerComponent(this);
    this.loadContentStore(this.props, this.context);
  }
  componentWillUnmount () {
    this.props.repoStore.unregisterComponent(this);
  }

  storeStateDidChange (originatingStore, callback) {
    this.loadContentStore(this.props, this.context, callback);
  }

  componentWilLReceiveProps (nextProps, nextContext) {
    this.loadContentStore(nextProps, nextContext);
  }



  loadContentStore (props, context, callback) {
    let state = {};
    let value = this.constructor.fromPropsOrContext(props, context, 'value');
    if (props.embedForm && value) {
      let content = props.repoStore.getContentByPath(value);
      if (content.content) {
        state.refContent = content.content;
      }
    }

    if (props.contentDropDown) {
      state.contentChoices = props.repoStore.getAllContent()
        .filter(content => content.content && content.path && content.path.startsWith(props.contentPathPrefix))
        .map(content => content.content);
    }
    this.setState(state, callback);
  }
  renderInput () {
    return <div>
      {this.props.contentDropDown
        ? this.renderDropDown()
        : super.renderInput()}
      <NavLink href={{
        view: 'admin/edit-content',
        params: {path: this.value},
      }}>Edit</NavLink>
      {this.renderEmbeddedForm()}
    </div>;
  }

  getPlaceholder () {
    return <option value="-">Choose...</option>;
  }

  updateSelect (ev) {
    this.handleChange({
      event: ev,
      value: ev.target.value,
    });
    this.fireCommitValue(ev, ev.target.value);
  }

  contentChoices () {
    if (!this.state.contentChoices) {
      return [{value: null, label: 'Loading...'}];
    }
    return this.state.contentChoices.map(content => ({value: content.path, label: content.adminLabel}));
  }

  renderDropDown () {
    return (
      <select
        required={this.required}
        disabled={this.disabled}
        value={this.value}
        onChange={ev => this.updateSelect(ev)}>
        {this.getPlaceholder()}
        {this.contentChoices().map(option => <option key={option.value} value={option.value}>{option.label}</option> )}
      </select>
    );
  }

  renderEmbeddedForm () {
    if (this.value && this.props.embedForm) {
      if ( this.state.refContent) {
        return cloneElement(
          this.props.embedForm,
          {
            content: this.state.refContent,
            repo: this.props.repo,
          }
        );
      } else {
        return <em>Loading {this.value}</em>;
      }


    } else {
      return [];
    }
  }
}
mergeStaticOptions(ContentRefInput, {
  propTypes: {
    value: PropTypes.object,
    committedValue: PropTypes.object,
    embedForm: PropTypes.bool,
    contentDropDown: PropTypes.bool,
    contentPathPrefix: PropTypes.string,
    repoStore: PropTypes.object,
  },
  defaultProps: {
    contentPathPrefix: '/content/',
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/ContentRefInput.jsx